/**
 * This enum handles the error code in response to building creation
 */
export enum BuildingCreationResponse {
  NO_EXCEPTION = 0,
  GENERIC_ERROR = 100,
  TAX_CODE_DUPLICATED = 101,
  TAX_CODE_EMPTY = 102,
  TAX_CODE_BAD_FORMAT = 103,
}